import React from 'react'
import PropTypes from 'prop-types'
import { SmartImage } from 'shared/UI/SmartImage'
import get from 'lodash/get'

import './style.css.scss'

const Logo = ({ image }) => {
  return get(image, 'url') && <SmartImage config={image} isImgTag={true} />
}

Logo.propTypes = {
  image: PropTypes.object
}

export default Logo